import { CheckboxWithToolTip } from 'components/WithTooltip';
import type { PriceListRatioCoefficientRowData } from 'gql/graphql';
import { Button, Checkbox, cnMixSpace, IconExpand } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import type React from 'react';
import { useCallback, useState } from 'react';

import { RatioUers } from '../../PriceList/RatioUers/RatioUers';

interface IAgreementPriceListRatioMenu extends ICellRendererParams<PriceListRatioCoefficientRowData> {
    checkedIds: Record<string, boolean>;
    disabledByStatus: boolean;
    isDisabledByProjectStatus: boolean;
    handleChangeCheckbox: (rowId: any) => any;
}
export const AgreementPriceListRatioMenu: React.FC<IAgreementPriceListRatioMenu> = (props) => {
    const { data, checkedIds, disabledByStatus, isDisabledByProjectStatus, handleChangeCheckbox } = props;

    const [isRatioUersOpen, setIsRatioUersOpen] = useState(false);

    const switchRatioUerModalOpen = useCallback(() => {
        setIsRatioUersOpen(!isRatioUersOpen);
    }, [isRatioUersOpen]);

    if (!data) {
        return <span />;
    }

    const checkBox = disabledByStatus ? (
        <CheckboxWithToolTip
            checkboxProps={{ checked: false }}
            tooltipProps={{
                mode: 'mouseover',
                content: 'Удаление возможно только в статусе "На формировании"',
            }}
            fakeDisabled
        />
    ) : (
        <Checkbox
            checked={checkedIds[data.id]}
            onChange={handleChangeCheckbox(data.id)}
            className={cnMixSpace({ mT: '3xs' })}
            disabled={disabledByStatus || isDisabledByProjectStatus}
        />
    );

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                {checkBox}
                <Button
                    onClick={switchRatioUerModalOpen}
                    iconLeft={IconExpand}
                    onlyIcon
                    view="clear"
                    size="xs"
                    style={{ marginLeft: 6 }}
                />
            </div>
            {isRatioUersOpen && <RatioUers onClose={switchRatioUerModalOpen} ratio={data} />}
        </>
    );
};

AgreementPriceListRatioMenu.displayName = 'AgreementPriceListRatioMenu';
